import { render, staticRenderFns } from "./IndexPresenter.vue?vue&type=template&id=c624cce4&lang=pug&"
import script from "./IndexPresenter.vue?vue&type=script&lang=ts&"
export * from "./IndexPresenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports